import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  & .hefesto-icon svg {
    margin: 1.5rem;
    width: 5rem;
    height: 4.25rem;
  }
`;
